import { VariantProps, cva } from "class-variance-authority";

import { cn } from "@/utils";

const headerVariants = cva("scroll-m-20 tracking-tight", {
    variants: {
        variant: {
            hero: "text-4xl font-extrabold lg:text-5xl",
            page: "border-b pb-2 text-3xl font-semibold first:mt-0",
            section: "text-2xl font-semibold",
            subsection: "text-lg font-semibold",
        },
    },
    defaultVariants: {
        variant: "page",
    },
});

export interface HeadingProps
    extends React.HTMLAttributes<HTMLHeadingElement>,
        VariantProps<typeof headerVariants> {
    as: "h1" | "h2" | "h3";
}

export function Heading({ as = "h1", className, variant, ...props }: HeadingProps) {
    const Comp = as;
    return <Comp className={cn(headerVariants({ variant }), className)} {...props} />;
}

export interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {}
export function Paragraph({ className, ...props }: ParagraphProps) {
    return <p className={cn("my-3 leading-7", className)} {...props} />;
}
